import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { ENABLE_AMENDMENT_V2_JOURNEY, ENABLE_ANNUAL_REPORT_V2_JOURNEY } from '#client/constants/experimentsFlags';

const SERVICE_TO_FLAG_MAPPING = {
  llc_amendment: ENABLE_AMENDMENT_V2_JOURNEY,
  llc_annual_report: ENABLE_ANNUAL_REPORT_V2_JOURNEY,
};

/**
 * Hook to retrieve experiment flag values for specific service codes.
 * such as llc_amendment and llc_annual_report, but scalable for future products.
 * For unmapped services, skips flag evaluation to optimize performance.
 * @param {string} serviceCode - The service code to retrieve the flag value for
 * @returns {object} An object with the flag value for the service code
 */
export const useServiceFlags = (serviceCode) => {
  const flagConstant = SERVICE_TO_FLAG_MAPPING[serviceCode];

  // skipEvaluation (!flagConstant) optimizes by skipping flag calls for unmapped services
  const flagValue = useExperimentFlag(flagConstant || '', false, false, !flagConstant);

  return flagConstant ? { [flagConstant]: flagValue } : {};
};
